import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FullScreenSpinner } from '../../../components/Spinner/Spinner';
import { useAppDispatch } from '../../../store';
import { useEffect } from 'react';
import { useLazyLoginQuery } from '../api/authApi';
import { toast } from 'react-toastify';
import { setAuthToken } from '../state/authSlice';
import { getErrorMessage } from '../../../utils';

export const LoginToken = () => {
  const navigate = useNavigate();
  const [login] = useLazyLoginQuery();
  const { token = '' } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  const checkToken = async () => {
    try {
      const res = await login({ token }).unwrap();
      const loginToken = res?.token;
      dispatch(setAuthToken(loginToken));
      toast('Login successful', { type: 'success' });
      
      // Check for redirect parameter, default to dashboard
      const returningEnabled = process.env.REACT_APP_GROUP_RETURNING_CONVERSION_ENABLED === 'true'
        || (process.env.REACT_APP_GROUP_PREVIEW === 'true' && ['localhost', '127.0.0.1'].includes(window.location.hostname));
      const redirectPath = searchParams.get('redirect') === '/activate/group/add'
        ? (returningEnabled ? '/activate/group/add' : '/activate/group') : '/dashboard';
      navigate(redirectPath);
    } catch (err) {
      const errString = getErrorMessage(err, "Couldn't login, please try again");
      toast(errString, { type: 'error' });
      navigate('/');
      return err;
    }
  };

  useEffect(() => {
    if (token) {
      checkToken();
    }
  }, [token]);
  return (
    <div>
      <FullScreenSpinner />
    </div>
  );
};
